import parse from 'html-react-parser';
import { FC } from 'react';

interface PostContentProps {
  contentHtml: string;
  ctaIcon: string;
  title: string;
  description: string;
  image: string;
}

const PostContent: FC<PostContentProps> = ({ contentHtml, ctaIcon }) => {
  const parsedContent = parse(contentHtml);
  const sections: JSX.Element[] = [];
  let currentSection: JSX.Element[] = [];
  let h3Content: JSX.Element[] = [];
  let h3Link: JSX.Element | null = null;
  const contentArray = Array.isArray(parsedContent) ? parsedContent : [parsedContent];

  contentArray.forEach(node => {
    if (typeof node === 'string') {
      return;
    }

    if (node.type === 'h1') {
      const titleText = node.props.children;

      const formattedTitleText = titleText.split('--').map((part: string) => (
        <span key={`title-part-${part.trim()}`}>
          {part.trim()}
          <br />
        </span>
      ));

      if (currentSection?.length > 0) {
        sections.push(<section key={`section-${sections?.length}`}>{currentSection}</section>);
        currentSection = [];
      }
      currentSection.push(<h1 key={`h1-${node.props.id}`}>{formattedTitleText}</h1>);
    } else if (node.type === 'h2') {
      if (currentSection?.length > 0) {
        sections.push(<section key={`section-${sections?.length}`}>{currentSection}</section>);
        currentSection = [];
      }
      currentSection.push(node);
    } else if (node.type === 'h3') {
      if (h3Content?.length > 0) {
        sections.push(
          <section key={`section-${sections?.length}`}>
            {h3Content}
            {h3Link}
          </section>,
        );
        h3Content = [];
        h3Link = null;
      }
      h3Content.push(node);
    } else if (node.type === 'p') {
      const textContent = node.props.children[0];
      if (node.props.children?.type === 'img') {
        const imgProps = {
          className: `seo-lp-hero`,
          width: `100%`,
          alt: node.props.children.props.alt || `image-${node.key}`,
          src: node.props.children.props.src,
        };
        sections.push(
          <picture key={`picture-${node.key}`}>
            <img alt="" {...imgProps} />
          </picture>,
        );
      } else if (typeof textContent === 'string' && textContent.includes('--')) {
        const [firstPart, secondPart] = textContent.split('--').map(part => part.trim());
        h3Content.push(<p key={`p-${node.key}-1`}>{firstPart}</p>);
        h3Content.push(<p key={`p-${node.key}-2`}>{secondPart}</p>);
        if (Array.isArray(node.props.children)) {
          const [, link] = node.props.children;
          h3Link = link;
          h3Content.push(h3Link);
        }
      } else {
        (h3Content?.length > 0 ? h3Content : currentSection).push(node);
      }
    } else if (node.type === 'a') {
      if (h3Content?.length > 0) {
        h3Link = node;
      } else {
        currentSection.push(node);
      }
    } else {
      sections.push(node);
    }
  });

  if (currentSection?.length > 0) {
    sections.push(<section key={`section-${sections?.length}`}>{currentSection}</section>);
  }

  if (h3Content.length > 0) {
    if (h3Content.length === 4) {
      const h3Heading = h3Content[0]?.props.children;
      const h3Text = h3Content[1]?.props.children;
      const secondPartText = h3Content[2]?.props.children;
      const ctaIconClass = `icon icon-${ctaIcon}`;
      const h3AnchorLink = h3Content[3]?.props.href;
      const h3AnchorText = h3Content[3]?.props.children;
      sections.push(
        <section key={`cta-${sections.length}`} className="cta">
          <span key={`icon-${sections.length}`} className={ctaIconClass} />
          <h3 key={`h3-${sections.length}`}>{h3Heading}</h3>
          <p key={`p-${sections.length}`}>{h3Text}</p>
          <p key={`p-${sections.length + 1}`}>{secondPartText}</p>
          {h3AnchorLink && (
            <a key={`a-${sections.length}`} className="cta-button" href={h3AnchorLink}>
              {h3AnchorText}
            </a>
          )}
        </section>,
      );
    } else {
      const h3Heading = h3Content[0]?.props.children;
      const h3Text = h3Content[1]?.props.children[0];
      const h3AnchorText = h3Content[1]?.props.children[1].props?.children;
      const h3AnchorLink = h3Content[1]?.props.children[1].props?.href;
      const ctaIconClass = `icon icon-${ctaIcon}`;
      sections.push(
        <section key={`cta-${sections.length}`} className="cta">
          <span key={`icon-${sections.length}`} className={ctaIconClass} />
          <h3 key={`h3-${sections.length}`}>{h3Heading}</h3>
          <p key={`p-${sections.length}`}>{h3Text}</p>
          <a key={`a-${sections.length}`} className="cta-button" href={h3AnchorLink}>
            {h3AnchorText}
          </a>
        </section>,
      );
    }
    h3Content = [];
    h3Link = null;
  }

  return <article className="landing-page">{sections}</article>;
};

export default PostContent;
